export default __webpack_public_path__ + "static/media/Kerry.e5767186.jpg";